import { Box, Typography } from '@mui/material';

export default function CopyrightFooter() {
  return <Box component="footer" sx={{ px: 2, py: 2, textAlign: 'center', bgcolor: 'rgba(5, 24, 34, 0.8)', color: '#fff' }}>
    <Typography variant="caption">
      © {new Date().getFullYear()} Kizuna Code. Todos los derechos reservados.
    </Typography>
  </Box>;
}
